/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import urls from "../../api/urls";
import NormalAPI from "../../api";

const {
    GET_BOOKED_VS_AUDITED_REPORT,
    GET_AUDITED_DETAILS_REPORT,
    GET_TOTAL_BOOKINGS_AUDIT_REPORT,
    GET_BOOKING_STATUS_REPORT,

    GET_INCOMING_LCR_REPORT,
    GET_OUTGOING_LCR_REPORT,
    GET_DELIVERY_STATUS_REPORT,
    GET_OUTSCAN_CP_INSCAN_REPORT,
    GET_HUB_AUDIT_REPORT,
    GET_MCN_LIST,
    GET_MCN_LIST_REPORT,
    GET_FORCE_BAG_REPORT,
    GET_FORCE_SHIPMENT_REPORT,
    GET_FORCE_ATTEMPT_BAG_REPORT_COUNT,
    GET_EXCESS_INSCAN_REPORT,
    GET_EXCESS_INSCAN_ENHANCED_REPORT,
    DOWNLOAD_EXCESS_INSCAN_ENHANCED_REPORT,
    GET_EWAY_BILL_REPORT,
    GET_LCR_TALLY_REPORT,
    GET_WRONG_SORTING_REPORT,
    DOWNLOAD_WRONG_SORTING_REPORT,
    GET_BOOKING_VS_DELIVERY_REPORT,
    DOWNLOAD_BOOKING_VS_DELIVERY_REPORT,
    GET_HUBWISE_SHIPMENTS_INSCAN_VS_OUTSCAN_REPORT,
    GET_HUB_INSCAN_CLICKABLE_REPORT,
    GET_CP_OUTSCAN_CLICKABLE_REPORT,
    GET_SHIPMENT_INSCAN_CLICKABLE_REPORT,
    GET_SHIPMENT_OUTSCAN_CLICKABLE_REPORT,
    GET_SHIPMENT_PENDING_CLICKABLE_REPORT,
    GET_CONTROL_TOWER_NEW_REPORT,
    GET_FINALIZED_BAGS_PENDING_OUTSCAN_REPORT,
    DOWNLOAD_FINALIZED_BAGS_PENDING_OUTSCAN_REPORT,
    GET_TOTAL_ASSIGNED_CLICKABLE_REPORT,
    GET_INSCANNED_AT_TRANSIT_CLICKABLE_REPORT,
    GET_INSCANNED_CLICKABLE_REPORT,
    GET_HUB_INSCANNED_CLICKABLE_REPORT,
    GET_TOTAL_AUDITED_CLICKABLE_REPORT,
    GET_CONTROL_TOWER_A3,
    GET_CONTROL_TOWER_STATUS_LIST,
    GET_CONTROL_TOWER_SERVICE_TYPE_LIST,
    GET_CONTROL_TOWER_CURRENT_HUB_LIST,
    GET_INSCANNED_SHIPMENTS_CLICKABLE_REPORT,
    GET_AUDITED_SHIPMENTS_CLICKABLE_REPORT,
    GET_NOT_AUDITED_SHIPMENTS_CLICKABLE_REPORT,
} = urls;

export const ReportsService = {
    getControlTowerStatusList: async (options = {}) => {
        try {
            const response = await NormalAPI.Api(GET_CONTROL_TOWER_STATUS_LIST).getCustomHeader(options);
            if (response?.status) {
                const data = response?.response?.data?.data || [];
                return data.map(item => ({ label: item, value: item }));
            }
            return [];
        } catch (error) {
            console.error("Error fetching Control Tower Status List:", error);
            return [];
        }
    },
    getControlTowerServiceTypeList: async (options = {}) => {
        try {
            const response = await NormalAPI.Api(GET_CONTROL_TOWER_SERVICE_TYPE_LIST).getCustomHeader(options);
            if (response?.status) {
                const data = response?.response?.data?.data || [];
                // Filter out nulls if any, as per sample response having null
                return data.filter(item => item !== null).map(item => ({ label: item, value: item }));
            }
            return [];
        } catch (error) {
            console.error("Error fetching Control Tower Service Type List:", error);
            return [];
        }
    },
    getControlTowerCurrentHubList: async (options = {}) => {
        try {
            const response = await NormalAPI.Api(GET_CONTROL_TOWER_CURRENT_HUB_LIST).getCustomHeader(options);
            if (response?.status) {
                const data = response?.response?.data?.data || [];
                return data.map(item => ({ label: item.currentHubName, value: item.currentHubId }));
            }
            return [];
        } catch (error) {
            console.error("Error fetching Control Tower Current Hub List:", error);
            return [];
        }
    },
    /**
     * Fetch booked vs audited report data
     * @param {Object} params - Report parameters
     * @param {string} [params.hubId] - Hub ID
     * @param {string} [params.hubName] - Hub name
     * @param {string} [params.cpId] - CP ID
     * @param {string} [params.cpName] - CP name
     * @param {string} [params.startDate] - Start date in YYYY-MM-DD format
     * @param {string} [params.endDate] - End date in YYYY-MM-DD format
     * @param {string} [params.docType] - Document type (dox/non-dox)
     * @param {number} [params.page=1] - Page number (1-based)
     * @param {number} [params.pageSize=10] - Number of items per page
     * @returns {Promise<{data: Array, total: number, page: number, pageSize: number}>} Report data with pagination info
     */


    getBookedVsAuditedReport: async (params, options = {}) => {
        // Transform params to match API requirements
        const requestBody = {
            fromDate: params.fromDate, // Use dynamic value
            toDate: params.toDate,     // Use dynamic value
            docTypes: params.docTypes, // Optional: only included if present
            // Convert array to comma-separated string to avoid array notation in query string
            cpids: Array.isArray(params.cpIds) ? params.cpIds.join(",") : params.cpIds,
            // Convert array to comma-separated string or single value
            hubids: Array.isArray(params.hubIds) ? params.hubIds.join(",") : params.hubIds,
            page: (params.page || 1) - 1,
            size: params.pageSize || 10,
        };
        // Remove undefined values
        const cleanBody = Object.fromEntries(
            Object.entries(requestBody).filter(([_, value]) => value != null && value !== "")
        );
        try {
            const response = await NormalAPI.Api(GET_BOOKED_VS_AUDITED_REPORT)
                .getwithParamsAuditReport(cleanBody, options);

            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                    lastRefreshedAt: response?.response?.data?.lastRefreshedAt || null,
                    nextScheduledRefresh: response?.response?.data?.nextScheduledRefresh || null,
                };
            }
            throw new Error(response?.message || "Failed to fetch report data");
        } catch (error) {
            console.error("Error fetching booked vs audited report:", error);
            throw error;
        }
    },

    /**
     * Fetch audited details report data
     * @param {Object} params - Report parameters
     * @param {string} params.bookingDate - Booking date in YYYY-MM-DD format
     * @param {number} [params.hubId] - Hub ID
     * @param {number} [params.cpId] - CP ID
     * @param {string} [params.docType] - Document type (dox/non-dox)
     * @param {number} [params.page=0] - Page number (0-based)
     * @param {number} [params.size=50] - Number of items per page
     * @param {Object} [options={}] - Additional options including signal for request cancellation
     * @returns {Promise<{data: Array, total: number}>} Report data with pagination info
     */
    getAuditedDetailsReport: async (params, options = {}) => {
        const queryParams = {
            bookingDate: params.bookingDate,
            ...(params.hubId && { hubId: params.hubId }),
            ...(params.cpId && { cpId: params.cpId }),
            ...(params.docType && { docType: params.docType }),
            page: params.page || 0,
            size: params.size || 50
        };

        // Remove undefined values
        const cleanParams = Object.fromEntries(
            Object.entries(queryParams).filter(([_, value]) => value != null)
        );

        const queryString = new URLSearchParams(cleanParams).toString();
        const url = `${GET_AUDITED_DETAILS_REPORT}?${queryString}`;

        try {
            const response = await NormalAPI.Api(url).getCustomHeader(options);

            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                };
            }
            throw new Error(response?.message || "Failed to fetch audited details report");
        } catch (error) {
            console.error("Error fetching audited details report:", error);
            throw error;
        }
    },

    /**
     * Fetch total bookings audit report data
     * @param {Object} params - Report parameters
     * @param {string} params.bookingDate - Booking date in YYYY-MM-DD format
     * @param {number} [params.hubId] - Hub ID
     * @param {number} [params.cpId] - CP ID
     * @param {string} [params.docType] - Document type (dox/non-dox)
     * @param {number} [params.page=0] - Page number (0-based)
     * @param {number} [params.size=50] - Number of items per page
     * @param {Object} [options={}] - Additional options including signal for request cancellation
     * @returns {Promise<{data: Array, total: number}>} Report data with pagination info
     */
    getTotalBookingsAuditReport: async (params, options = {}) => {
        const queryParams = {
            bookingDate: params.bookingDate,
            ...(params.hubId && { hubId: params.hubId }),
            ...(params.cpId && { cpId: params.cpId }),
            ...(params.docType && { docType: params.docType }),
            page: params.page || 0,
            size: params.size || 50
        };

        // Remove undefined values
        const cleanParams = Object.fromEntries(
            Object.entries(queryParams).filter(([_, value]) => value != null)
        );

        const queryString = new URLSearchParams(cleanParams).toString();
        const url = `${GET_TOTAL_BOOKINGS_AUDIT_REPORT}?${queryString}`;

        try {
            const response = await NormalAPI.Api(url).getCustomHeader(options);

            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                };
            }
            throw new Error(response?.message || "Failed to fetch total bookings audit report");
        } catch (error) {
            console.error("Error fetching total bookings audit report:", error);
            throw error;
        }
    },

    /**
     * Fetch Force Shipment Scan report data
     */
    getForceShipmentReport: async (params, options = {}) => {
        const queryParams = {
            fromDate: params.fromDate,
            toDate: params.toDate,
            ...(params.premiseIds && { premiseIds: Array.isArray(params.premiseIds) ? params.premiseIds.join(",") : params.premiseIds }),
            page: params.page ?? 0,
            size: params.size ?? 10
        };

        const cleanParams = Object.fromEntries(
            Object.entries(queryParams).filter(([_, value]) => value != null && value !== "")
        );

        try {
            const response = await NormalAPI.Api(GET_FORCE_SHIPMENT_REPORT)
                .getwithParamsAuditReport(cleanParams, options);

            if (response?.response?.status === 200) {
                const raw = response?.response?.data?.data || [];
                const normalized = raw.map(item => ({
                    premiseId: item.premiseId,
                    premiseName: item.premiseName,
                    dateId: item.dateId,
                    totalForceshipmentScan: item.totalForceshipmentScan
                }));
                return {
                    data: normalized,
                    total: response?.response?.data?.count || normalized.length,
                };
            }
            throw new Error(response?.message || "Failed to fetch Force Shipment report");
        } catch (error) {
            console.error("Error fetching Force Shipment report", error);
            throw error;
        }
    },

    /**
     * Fetch Force Bag report data
     * @param {Object} params
     * @param {string} params.fromDate - YYYY-MM-DD
     * @param {string} params.toDate - YYYY-MM-DD
     * @param {string|string[]} [params.premiseIds] - comma string or array
     * @param {number} [params.page=0]
     * @param {number} [params.size=10]
     */
    getForceBagReport: async (params, options = {}) => {
        const queryParams = {
            fromDate: params.fromDate,
            toDate: params.toDate,
            ...(params.premiseIds && { premiseIds: Array.isArray(params.premiseIds) ? params.premiseIds.join(",") : params.premiseIds }),
            page: params.page ?? 0,
            size: params.size ?? 10,
            ...(params.bagAwbNumber && { bagAwbNumber: params.bagAwbNumber }),
            ...(params.shipmentAwbNumber && { shipmentAwbNumber: params.shipmentAwbNumber })
        };

        const cleanParams = Object.fromEntries(
            Object.entries(queryParams).filter(([_, value]) => value != null && value !== "")
        );

        try {
            const response = await NormalAPI.Api(GET_FORCE_BAG_REPORT)
                .getwithParamsAuditReport(cleanParams, options);

            if (response?.response?.status === 200) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                };
            }
            throw new Error(response?.message || "Failed to fetch Force Bag report");
        } catch (error) {
            console.error("Error fetching Force Bag report", error);
            throw error;
        }
    },

    /**
     * Fetch Force Bag Attempt Shipment  Count data
     * @param {Object} params
     * @param {string} params.fromDate - YYYY-MM-DD
     * @param {string} params.toDate - YYYY-MM-DD
     * @param {string|string[]} [params.premiseIds] - comma string or array
     * @param {number} [params.page=0]
     * @param {number} [params.size=10]
     */
    getForceAttemptBagReportCount: async (params, options = {}) => {
        const queryParams = {
            fromDate: params.fromDate,
            toDate: params.toDate,
            ...(params.premiseIds && { premiseIds: Array.isArray(params.premiseIds) ? params.premiseIds.join(",") : params.premiseIds }),
            page: params.page ?? 0,
            size: params.size ?? 10
        };

        const cleanParams = Object.fromEntries(
            Object.entries(queryParams).filter(([_, value]) => value != null && value !== "")
        );

        try {
            const response = await NormalAPI.Api(GET_FORCE_ATTEMPT_BAG_REPORT_COUNT)
                .getwithParamsAuditReport(cleanParams, options);

            if (response?.response?.status === 200) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                };
            }
            throw new Error(response?.message || "Failed to fetch Force Bag Attempt Shipment  Count");
        } catch (error) {
            console.error("Error fetching Force Bag Attempt Shipment  Count", error);
            throw error;
        }
    },

    getBookingStatusReport: async (params, options = {}) => {
        // Transform params to match API requirements
        const requestBody = {
            fromDate: params.startDate,
            toDate: params.endDate,
            fromHubs: params.hubNames ? params.hubNames : undefined,
            fromcps: params.cpNames ? params.cpNames : undefined,
            pageNum: (params.page || 1) - 1, // API expects 0-based
            pageSize: params.pageSize || 10
        };
        // Remove undefined values
        const cleanBody = Object.fromEntries(
            Object.entries(requestBody).filter(([_, value]) => value != null)
        );
        try {
            const response = await NormalAPI.Api(GET_BOOKING_STATUS_REPORT)
                .postWithHeaderOptions(cleanBody, options);
            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                    page: (cleanBody.pageNum || 0) + 1,
                    pageSize: cleanBody.pageSize,
                    lastRefreshedAt: response?.response?.data?.lastRefreshedAt || null,
                    nextScheduledRefresh: response?.response?.data?.nextScheduledRefresh || null,
                };
            }
            throw new Error(response?.message || "Failed to fetch booking status report");
        } catch (error) {
            console.error("Error fetching booking status report:", error);
            throw error;
        }
    },

    getBookingVsInscanOutscanReport: async (params, options = {}) => {
        const requestBody = {
            fromDate: params.startDate,
            toDate: params.endDate,
            bookingCp: params.cpNames ? params.cpNames : undefined,
            toHub: params.hubNames ? params.hubNames : undefined,
            audit: params.audit ? params.audit : [],
            pageNum: (params.page || 1) - 1, // API expects 0-based
            pageSize: params.pageSize || 10
        };
        // Remove undefined values
        const cleanBody = Object.fromEntries(
            Object.entries(requestBody).filter(([_, value]) => value != null)
        );
        try {
            const response = await NormalAPI.Api(urls.GET_BOOKING_VS_INSCAN_OUTSCAN_REPORT)
                .postWithHeader(cleanBody, options);
            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                    page: (cleanBody.pageNum || 0) + 1,
                    pageSize: cleanBody.pageSize,
                    lastRefreshedAt: response?.response?.data?.lastRefreshedAt || null,
                    nextScheduledRefresh: response?.response?.data?.nextScheduledRefresh || null,

                };
            }
            throw new Error(response?.message || "Failed to fetch booking-vs-inscan-outscan report");
        } catch (error) {
            console.error("Error fetching booking-vs-inscan-outscan report:", error);
            throw error;
        }
    },

    getHubAuditEntryReport: async (params, options = {}) => {
        const requestBody = {
            startDate: params.startDate,
            endDate: params.endDate,
            entryTypes: params.entryTypes,
            auditedHubs: params.auditedHubs,
            awbNumbers: params.awbNumbers,
            serviceTypes: params.serviceTypes,
            travelBy: params.travelBy,
            pageNum: (params.page || 1) - 1,
            pageSize: params.pageSize || 10
        };
        const cleanBody = Object.fromEntries(
            Object.entries(requestBody).filter(([_, value]) => value != null && (Array.isArray(value) ? value.length > 0 : true))
        );
        try {
            const response = await NormalAPI.Api(urls.GET_HUB_AUDIT_ENTRY_REPORT)
                .postWithHeaderOptions(cleanBody, options);
            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                    page: (cleanBody.pageNum || 0) + 1,
                    pageSize: cleanBody.pageSize,
                    lastRefreshedAt: response?.response?.data?.lastRefreshedAt || null,
                    nextScheduledRefresh: response?.response?.data?.nextScheduledRefresh || null,

                };
            }
            throw new Error(response?.message || "Failed to fetch hub audit entry report");
        } catch (error) {
            console.error("Error fetching hub audit entry report:", error);
            throw error;
        }
    },

    /**
     * Fetch incoming bag report data
     * @param {Object} params - Report parameters
     * @param {string} [params.startDate] - Start date in YYYY-MM-DD format
     * @param {string} [params.endDate] - End date in YYYY-MM-DD format
     * @param {string[]} [params.bagNumbers] - Array of bag numbers
     * @param {string[]} [params.fromHubs] - Array of from hub names
     * @param {string[]} [params.toHubs] - Array of to hub names
     * @param {string[]} [params.transportTypes] - Array of transport types (e.g. ["SURFACE", "AIR"])
     * @param {number} [params.pageNum=0] - Page number (0-based)
     * @param {number} [params.pageSize=10] - Number of items per page
     * @returns {Promise<{data: Array, total: number, page: number, pageSize: number}>} Report data with pagination info
     */
    getIncomingBagReport: async (params) => {
        const requestBody = {
            startDate: params.startDate,
            endDate: params.endDate,
            bagNumbers: params.bagNumbers,
            fromHubs: params.fromHubs,
            toHubs: params.toHubs,
            transportTypes: params.transportTypes,
            pageNum: params.pageNum || 0,
            pageSize: params.pageSize || 10
        };

        // Remove undefined values
        const cleanBody = Object.fromEntries(
            Object.entries(requestBody).filter(([_, value]) => value != null)
        );

        try {
            const response = await NormalAPI.Api(urls.GET_INCOMING_BAG_REPORT)
                .postWithHeader(cleanBody);

            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                    page: cleanBody.pageNum,
                    pageSize: cleanBody.pageSize,
                    lastRefreshedAt: response?.response?.data?.lastRefreshedAt || null,
                    nextScheduledRefresh: response?.response?.data?.nextScheduledRefresh || null,
                };
            }
            throw new Error(response?.message || "Failed to fetch incoming bag report");
        } catch (error) {
            console.error("Error fetching incoming bag report:", error);
            throw error;
        }
    },

    /**
     * Fetch outgoing bag report data
     * @param {Object} params - Report parameters
     * @param {string} [params.fromDate] - Start date in YYYY-MM-DD format
     * @param {string} [params.toDate] - End date in YYYY-MM-DD format
     * @param {string[]} [params.fromHubIds] - Array of from hub IDs
     * @param {string[]} [params.toHubIds] - Array of to hub IDs
     * @param {string} [params.transportMode] - Transport mode (surface/air)
     * @param {string} [params.bagNo] - Bag number filter
     * @param {number} [params.pageNum=0] - Page number (0-based)
     * @param {number} [params.pageSize=10] - Number of items per page
     * @returns {Promise<{data: Array, total: number, page: number, pageSize: number}>} Report data with pagination info
     */
    getOutgoingBagReport: async (params) => {
        const requestBody = {
            fromDate: params.fromDate,
            toDate: params.toDate,
            fromHubIds: params.fromHubIds ? params.fromHubIds.join(",") : undefined,
            toHubIds: params.toHubIds ? params.toHubIds.join(",") : undefined,
            transportMode: params.transportMode,
            bagNo: params.bagNo ? params.bagNo.join(",") : undefined,
            pageNum: params.pageNum || 0,
            pageSize: params.pageSize || 10
        };

        // Remove undefined values
        const cleanBody = Object.fromEntries(
            Object.entries(requestBody).filter(([_, value]) => value != null)
        );
        const queryString = new URLSearchParams(cleanBody).toString();
        const url = `${urls.GET_OUTGOING_BAG_REPORT}?${queryString}`;

        try {
            const response = await NormalAPI.Api(url)
                .getCustomHeader();

            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                    page: cleanBody.pageNum,
                    pageSize: cleanBody.pageSize,
                    lastRefreshedAt: response?.response?.data?.lastRefreshedAt || null,
                    nextScheduledRefresh: response?.response?.data?.nextScheduledRefresh || null,

                };
            }
            throw new Error(response?.message || "Failed to fetch outgoing bag report");
        } catch (error) {
            console.error("Error fetching outgoing bag report:", error);
            throw error;
        }
    },

    /**
     * Fetch fast track report data
     * @param {Object} params - Report parameters
     * @param {string} [params.fromDate] - Start date in YYYY-MM-DD format
     * @param {string} [params.toDate] - End date in YYYY-MM-DD format
     * @param {string[]} [params.parentHubIds] - Array of parent hub IDs
     * @param {string[]} [params.bookingCpIds] - Array of booking CP IDs
     * @param {string[]} [params.zones] - Array of zones
     * @param {string[]} [params.serviceTypes] - Array of service types
     * @param {number} [params.page=0] - Page number (0-based)
     * @param {number} [params.size=10] - Number of items per page
     * @returns {Promise<{data: Array, total: number, page: number, size: number}>} Report data with pagination info
     */
    getFastTrackReport: async (params) => {
        const requestBody = {
            fromDate: params.fromDate,
            toDate: params.toDate,
            parentHubIds: params.parentHubIds ? params.parentHubIds.join(",") : undefined,
            destinationHubIds: params.destinationHubIds ? params.destinationHubIds.join(",") : undefined,
            bookingCpIds: params.bookingCpIds ? params.bookingCpIds.join(",") : undefined,
            zones: params.zones ? params.zones.join(",") : undefined,
            serviceTypes: params.serviceTypes ? params.serviceTypes.join(",") : undefined,
            bookingTypes: params.bookingTypes ? params.bookingTypes.join(",") : undefined,
            page: params.page || 0,
            size: params.size || 10
        };

        // Remove undefined values
        const cleanBody = Object.fromEntries(
            Object.entries(requestBody).filter(([_, value]) => value != null)
        );
        const queryString = new URLSearchParams(cleanBody).toString();
        const url = `${urls.GET_FASTTRACK_REPORT}?${queryString}`;

        try {
            const response = await NormalAPI.Api(url)
                .getCustomHeader();

            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                    page: cleanBody.page,
                    size: cleanBody.size,
                    lastRefreshedAt: response?.response?.data?.lastRefreshedAt || null,
                    nextScheduledRefresh: response?.response?.data?.nextScheduledRefresh || null,

                };
            }
            throw new Error(response?.message || "Failed to fetch fast track report");
        } catch (error) {
            console.error("Error fetching fast track report:", error);
            throw error;
        }
    },

    /**
     * Fetch delivery MIS report data
     * @param {Object} params - Report parameters
     * @param {string} [params.startDate] - Start date in YYYY-MM-DD format
     * @param {string} [params.endDate] - End date in YYYY-MM-DD format
     * @param {string} [params.hubId] - Comma-separated hub IDs
     * @param {string} [params.cpId] - Comma-separated CP IDs
     * @param {number} [params.page=1] - Page number
     * @param {number} [params.limit=10] - Number of items per page
     * @returns {Promise<{data: Array, total: number, page: number, limit: number}>} Report data with pagination info
     */
    getDeliveryMISReport: async (params) => {
        const requestBody = {
            startDate: params.startDate,
            endDate: params.endDate,
            hubId: params.hubId,
            cpId: params.cpId,
            page: params.page || 1,
            limit: params.limit || 10
        };

        // Remove undefined values
        const cleanBody = Object.fromEntries(
            Object.entries(requestBody).filter(([_, value]) => value != null)
        );

        // Construct query string
        const queryString = new URLSearchParams(cleanBody).toString();
        const url = `${urls.GET_DELIVERY_MIS_REPORT}?${queryString}`;

        try {
            const response = await NormalAPI.Api(url)
                .getCustomHeader();
            if (response?.response?.status === 200) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.pagination?.totalCount || 0,
                    page: response?.response?.data?.pagination?.totalPages || 1,
                    limit: response?.response?.data?.pagination?.limit || 10
                };
            }
            throw new Error(response?.message || "Failed to fetch delivery MIS report");
        } catch (error) {
            console.error("Error fetching delivery MIS report:", error);
            throw error;
        }
    },


    /**
     * Fetch control tower hub report data
     * @param {Object} params - Report parameters
     * @param {string} [params.originHubId] - Origin hub ID(s) - comma separated
     * @param {string} [params.destinationHubId] - Destination hub ID(s) - comma separated
     * @param {string} [params.fromDate] - Start date in YYYY-MM-DD format
     * @param {string} [params.toDate] - End date in YYYY-MM-DD format
     * @param {string} [params.currentStatus] - Status filter(s) - comma separated
     * @param {string} [params.serviceType] - Service type filter(s) - comma separated
     * @param {string} [params.bookingType] - Booking type filter(s) - comma separated
     * @param {string} [params.documentType] - Document type filter(s) - comma separated
     * @param {number} [params.page=0] - Page number (0-based)
     * @param {number} [params.size=10] - Number of items per page
     * @param {Object} [options={}] - Additional options including signal for request cancellation
     * @returns {Promise<{data: Array, total: number, page: number, size: number}>} Report data with pagination info
     */
    getControlTowerHubReport: async (params, options = {}) => {
        // Construct query parameters
        const queryParams = {
            fromDate: params.fromDate,
            toDate: params.toDate,
            currentStatus: params.currentStatus,
            destinationHubId: params.destinationHubId,
            originHubId: params.originHubId,
            serviceType: params.serviceType,
            bookingType: params.bookingType,
            documentType: params.documentType,
            page: params.page || 0,
            size: params.size || 10
        };

        // Remove undefined values
        const cleanParams = Object.fromEntries(
            Object.entries(queryParams).filter(([_, value]) => value != null)
        );

        // Construct query string
        const queryString = new URLSearchParams(cleanParams).toString();
        const url = `${urls.GET_CONTROL_TOWER_HUB_REPORT}?${queryString}`;

        try {
            const response = await NormalAPI.Api(url).getCustomHeader(options);
            if (response?.response?.status === 200) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                    lastRefreshedAt: response?.response?.data?.lastRefreshedAt || null,
                    nextScheduledRefresh: response?.response?.data?.nextScheduledRefresh || null,
                };
            }
            throw new Error(response?.message || "Failed to fetch control tower hub report");
        } catch (error) {
            console.error("Error fetching control tower hub report:", error);
            throw error;
        }
    },

    /**
     * Fetch incoming shipment control tower report data
     * @param {Object} params - Report parameters
     * @param {string} [params.originHubIdList] - Origin hub ID(s) - comma separated
     * @param {string} [params.destinationHubId] - Destination hub ID(s) - comma separated
     * @param {string} [params.fromDate] - Start date in YYYY-MM-DD format
     * @param {string} [params.toDate] - End date in YYYY-MM-DD format
     * @param {string} [params.currentStatus] - Status filter(s) - comma separated
     * @param {string} [params.serviceType] - Service type filter(s) - comma separated
     * @param {string} [params.bookingType] - Booking type filter(s) - comma separated
     * @param {string} [params.documentType] - Document type filter(s) - comma separated
     * @param {number} [params.page=0] - Page number (0-based)
     * @param {number} [params.size=10] - Number of items per page
     * @param {Object} [options={}] - Additional options including signal for request cancellation
     * @returns {Promise<{data: Array, total: number, page: number, size: number}>} Report data with pagination info
     */
    getIncomingShipmentControlTowerReport: async (params, options = {}) => {
        // Construct query parameters
        const queryParams = {
            fromDate: params.fromDate,
            toDate: params.toDate,
            currentStatus: params.currentStatus,
            destinationHubId: params.destinationHubId,
            originHubIdList: params.originHubIdList,
            serviceType: params.serviceType,
            bookingType: params.bookingType,
            documentType: params.documentType,
            page: params.page || 0,
            size: params.size || 10
        };

        // Remove undefined values
        const cleanParams = Object.fromEntries(
            Object.entries(queryParams).filter(([_, value]) => value != null)
        );

        // Construct query string
        const queryString = new URLSearchParams(cleanParams).toString();
        const url = `${urls.GET_INCOMING_SHIPMENT_PENDENCY_REPORT}?${queryString}`;

        try {
            const response = await NormalAPI.Api(url).getCustomHeader(options);
            if (response?.response?.status === 200) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                    lastRefreshedAt: response?.response?.data?.lastRefreshedAt || null,
                    nextScheduledRefresh: response?.response?.data?.nextScheduledRefresh || null,
                };
            }
            throw new Error(response?.message || "Failed to fetch incoming shipment control tower report");
        } catch (error) {
            console.error("Error fetching incoming shipment control tower report:", error);
            throw error;
        }
    },

    /**
     * Fetch VayuQuickPro report data
     * @param {Object} params - Report parameters
     * @param {string} [params.bookingHubIds] - Booking hub ID(s) - comma separated
     * @param {string} [params.destinationHubIds] - Destination hub ID(s) - comma separated
     * @param {string} [params.startDate] - Start date in YYYY-MM-DD format
     * @param {string} [params.endDate] - End date in YYYY-MM-DD format
     * @param {number} [params.pageNum=1] - Page number (1-based)
     * @param {number} [params.pageSize=10] - Number of items per page
     * @returns {Promise<{data: Array, total: number, page: number, size: number}>} Report data with pagination info
     */
    getVayuQuickProReport: async (params) => {
        // Construct query parameters
        const queryParams = {
            bookingHubIds: params.bookingHubIds,
            destinationHubIds: params.destinationHubIds,
            startDate: params.startDate,
            endDate: params.endDate,
            pageNum: params.pageNum || 1,
            pageSize: params.pageSize || 10
        };

        // Remove undefined values
        const cleanParams = Object.fromEntries(
            Object.entries(queryParams).filter(([_, value]) => value != null)
        );

        // Construct query string
        const queryString = new URLSearchParams(cleanParams).toString();
        const url = `${urls.GET_VAYUQUICK_PRO_REPORT}?${queryString}`;

        try {
            const response = await NormalAPI.Api(url).getCustomHeader();
            if (response?.response?.status === 200) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                    lastRefreshedAt: response?.response?.data?.lastRefreshedAt || null,
                    nextScheduledRefresh: response?.response?.data?.nextScheduledRefresh || null,
                };
            }
            throw new Error(response?.message || "Failed to fetch VayuQuickPro report");
        } catch (error) {
            console.error("Error fetching VayuQuickPro report:", error);
            throw error;
        }
    },

    getDRSReport: async (params) => {
        const { startDate, endDate, cpId, key, page, limit, hubId } = params;
        const userId = localStorage.getItem("userId");
        const userInfo = userId ? JSON.parse(userId) : {};
        const premiseId = userInfo?.userInfo?.premiseId;

        const requestBody = {
            startDate,
            endDate,
            cpId,
            key,
            page: page || 1,
            limit: limit || 10,
            hubId
        };

        // Remove undefined values
        const cleanBody = Object.fromEntries(
            Object.entries(requestBody).filter(([_, value]) => value != null)
        );

        // Construct query string
        const queryString = new URLSearchParams(cleanBody).toString();
        const url = `${urls.GET_DRS_REPORT}?${queryString}`;

        try {
            const response = await NormalAPI.Api(url).getWithAllHeaders();

            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.pagination?.totalCount || 0,
                    page: response?.response?.data?.pagination?.totalPages || 1,
                    limit: response?.response?.data?.pagination?.limit || 10
                };
            }
            throw new Error(response?.message || "Failed to fetch DRS report");
        } catch (error) {
            console.error("Error fetching DRS report:", error);
            throw error;
        }
    },

    /**
     * Fetch incoming LCR report data
     * @param {Object} params - Report parameters
     * @param {string} [params.originHubId] - Origin hub ID(s) - comma separated
     * @param {string} [params.destinationHubId] - Destination hub ID(s) - comma separated
     * @param {string} [params.fromDate] - Start date in YYYY-MM-DD format
     * @param {string} [params.toDate] - End date in YYYY-MM-DD format
     * @param {string} [params.currentStatus] - Status filter(s) - comma separated
     * @param {number} [params.page=0] - Page number (0-based)
     * @param {number} [params.size=10] - Number of items per page
     * @returns {Promise<{data: Array, total: number, page: number, size: number}>} Report data with pagination info
     */


    getMCNListReport: async (params, userId) => {
        // Construct query parameters
        const queryParams = {
            from: params.fromDate,
            to: params.toDate,
            ...(params.partnerCodes && {
                partnerCode: params.partnerCodes
            }),
            ...(params.bookingTypes && {
                bookingType: params.bookingTypes
            }),
            page: params.page - 1 || 0,
            size: params.size || 10,
            search: params.search
        };

        // Remove undefined values
        const cleanParams = Object.fromEntries(
            Object.entries(queryParams).filter(([_, value]) => value != null)
        );

        // Construct query string
        const queryString = new URLSearchParams(cleanParams).toString();

        try {
            const response = await NormalAPI.Api(GET_MCN_LIST + "/" + userId + "?" + queryString)
                .getCustomHeader(cleanParams);

            if (response?.response?.status === 200) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                };
            }
            throw new Error(response?.message || "Failed to fetch incoming LCR report");
        } catch (error) {
            console.error("Error fetching incoming LCR report", error);
            throw error;
        }
    },

    /**
     * Fetch MCN report data (new method for Reports section)
     * @param {Object} params - Report parameters
     * @param {string} [params.fromDate] - Start date in YYYY-MM-DD format
     * @param {string} [params.toDate] - End date in YYYY-MM-DD format
     * @param {string} [params.originHubIds] - Origin hub ID(s) - comma separated
     * @param {string} [params.destinationHubIds] - Destination hub ID(s) - comma separated
     * @param {string} [params.bookingType] - Booking type filter
     * @param {string} [params.doxNondoxTypes] - Document type filter (dox/non-dox)
     * @param {number} [params.page=0] - Page number (0-based)
     * @param {number} [params.size=10] - Number of items per page
     * @returns {Promise<{data: Array, total: number}>} Report data with pagination info
     */
    getMCNReport: async (params, options = {}) => {
        // Construct query parameters
        const queryParams = {
            fromDate: params.fromDate,
            toDate: params.toDate,
            ...(params.originHubIds && { originHubIds: params.originHubIds }),
            ...(params.destinationHubIds && { destinationHubIds: params.destinationHubIds }),
            ...(params.currentHubIds && { currentHubIds: params.currentHubIds }),
            ...(params.currentStatuses && { currentStatuses: params.currentStatuses }),
            ...(params.bookingType && { bookingTypes: params.bookingType }),
            ...(params.doxNondoxTypes && { doxNondoxTypes: params.doxNondoxTypes }),
            page: params.page || 0,
            size: params.size || 10
        };

        // Remove undefined values
        const cleanParams = Object.fromEntries(
            Object.entries(queryParams).filter(([_, value]) => value != null)
        );

        try {
            const response = await NormalAPI.Api(GET_MCN_LIST_REPORT)
                .getwithParamsAuditReport(cleanParams, options);

            if (response?.response?.status === 200) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                };
            }
            throw new Error(response?.message || "Failed to fetch MCN report");
        } catch (error) {
            console.error("Error fetching MCN report", error);
            throw error;
        }
    },

    getIncomingLCRReport: async (params, options = {}) => {
        // Construct query parameters
        const queryParams = {
            fromDate: params.fromDate,
            toDate: params.toDate,
            ...(params.hubIds && params.hubIds[0] && { toPremiseIds: params.hubIds[0] }),
            ...(params.destinationHubId && { fromHubs: params.destinationHubId }),
            ...(params.stopLcrNums && { stopLcrNums: params.stopLcrNums }),
            page: params.page || 0,
            size: params.size || 10
        };
        // Remove undefined valuesx
        const cleanParams = Object.fromEntries(
            Object.entries(queryParams).filter(([_, value]) => value != null)
        );

        // Construct query string
        // const queryString = new URLSearchParams(cleanParams).toString();
        // const url = `${urls.GET_INCOMING_LCR_REPORT}?${queryString}`;

        try {
            //const response = await NormalAPI.Api(url).getCustomHeader();

            const response = await NormalAPI.Api(GET_INCOMING_LCR_REPORT)
                .getwithParamsAuditReport(cleanParams, options);



            if (response?.response?.status === 200) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                    lastRefreshedAt: response?.response?.data?.lastRefreshedAt || null,
                    nextScheduledRefresh: response?.response?.data?.nextScheduledRefresh || null,
                };
            }
            throw new Error(response?.message || "Failed to fetch incoming LCR report");
        } catch (error) {
            console.error("Error fetching incoming LCR report", error);
            throw error;
        }
    },
    getLCRTallyLCRReport: async (params, options = {}) => {
        // Construct query parameters
        const queryParams = {
            fromDate: params.fromDate,
            toDate: params.toDate,
            ...(params.hubIds && params.hubIds[0] && { toPremiseIds: params.hubIds[0] }),
            ...(params.destinationHubId && { fromPremiseIds: params.destinationHubId }),
            ...(params.tripStatus && { tripStatus: params.tripStatus }),
            ...(params.stopLcrNums && { stopLcrNums: params.stopLcrNums }),
            ...(params.vehicleLcrNums && { vehicleLcrNums: params.vehicleLcrNums }),
            pageNum: params.page || 0,
            pageSize: params.size || 10
        };
        // Remove undefined valuesx
        const cleanParams = Object.fromEntries(
            Object.entries(queryParams).filter(([_, value]) => value != null)
        );

        // Construct query string
        // const queryString = new URLSearchParams(cleanParams).toString();
        // const url = `${urls.GET_INCOMING_LCR_REPORT}?${queryString}`;

        try {
            //const response = await NormalAPI.Api(url).getCustomHeader();

            const response = await NormalAPI.Api(GET_LCR_TALLY_REPORT)
                .getwithParamsAuditReport(cleanParams, options);



            if (response?.response?.status === 200) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                    lastRefreshedAt: response?.response?.data?.lastRefreshedAt || null,
                    nextScheduledRefresh: response?.response?.data?.nextScheduledRefresh || null,
                };
            }
            throw new Error(response?.message || "Failed to fetch incoming LCR report");
        } catch (error) {
            console.error("Error fetching incoming LCR report", error);
            throw error;
        }
    },
    getOutComingLCRReport: async (params, options = {}) => {
        // Construct query parameters
        const queryParams = {
            fromDate: params.fromDate,
            toDate: params.toDate,
            fromHubs: params.originHubId,
            toPremiseIds: params.destinationHubId,
            ...(params.stopLcrNums && { stopLcrNums: params.stopLcrNums }),
            page: params.page || 0,
            size: params.size || 10
        };

        // Remove undefined values
        const cleanParams = Object.fromEntries(
            Object.entries(queryParams).filter(([_, value]) => value != null)
        );

        // Construct query string
        // const queryString = new URLSearchParams(cleanParams).toString();
        // const url = `${urls.GET_OUTGOING_LCR_REPORT}?${queryString}`;

        try {
            const response = await NormalAPI.Api(GET_OUTGOING_LCR_REPORT)
                .getwithParamsAuditReport(cleanParams, options);


            if (response?.response?.status === 200) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                    lastRefreshedAt: response?.response?.data?.lastRefreshedAt || null,
                    nextScheduledRefresh: response?.response?.data?.nextScheduledRefresh || null,
                };
            }
            throw new Error(response?.message || "Failed to fetch incoming LCR report");
        } catch (error) {
            console.error("Error fetching incoming LCR report", error);
            throw error;
        }
    },
    getDeliverStatusReport: async (params, options = {}) => {
        // Construct query parameters
        const queryParams = {
            fromDate: params.fromDate,
            toDate: params.toDate,
            fromPremiseIds: params.originHubId,
            toPremiseIds: params.destinationHubId,
            awbNumbers: params.awbSearch,
            status: params.currentStatus,
            pageNum: params.page || 0,
            pageSize: params.size || 10
        };

        // Remove undefined values
        const cleanParams = Object.fromEntries(
            Object.entries(queryParams).filter(([_, value]) => value != null)
        );

        // Construct query string
        // const queryString = new URLSearchParams(cleanParams).toString();
        // const url = `${urls.GET_OUTGOING_LCR_REPORT}?${queryString}`;

        try {
            const response = await NormalAPI.Api(GET_DELIVERY_STATUS_REPORT)
                .getwithParamsAuditReport(cleanParams, options);


            if (response?.response?.status === 200) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                    lastRefreshedAt: response?.response?.data?.lastRefreshedAt || null,
                    nextScheduledRefresh: response?.response?.data?.nextScheduledRefresh || null,
                };
            }
            throw new Error(response?.message || "Failed to fetch delivery status report");
        } catch (error) {
            console.error("Error fetching delivery status report", error);
            throw error;
        }
    },
    getOutScanVsInscanReport: async (params, options = {}) => {
        // Construct query parameters
        const queryParams = {
            fromDate: params.fromDate,
            toDate: params.toDate,
            ...(params.originHubId && { fromHubIds: params.originHubId }),
            ...(params.destinationHubId && { cpIds: params.destinationHubId }),
            pageNum: params.page || 0,
            pageSize: params.size || 10
        };

        // Remove undefined values
        const cleanParams = Object.fromEntries(
            Object.entries(queryParams).filter(([_, value]) => value != null && value !== "")
        );

        try {
            const response = await NormalAPI.Api(GET_OUTSCAN_CP_INSCAN_REPORT)
                .getwithParamsAuditReport(cleanParams, options);

            if (response?.status || response?.response?.status === 200 || response?.response?.data?.code === 200) {
                const responseData = response?.response?.data || response?.data || response;
                return {
                    data: responseData?.data || [],
                    total: responseData?.count || 0,
                    lastRefreshedAt: responseData?.lastRefreshedAt || null,
                    nextScheduledRefresh: responseData?.nextScheduledRefresh || null,
                };
            }
            throw new Error(response?.message || response?.response?.data?.message || "Failed to fetch report data");
        } catch (error) {
            console.error("Error fetching outscan vs cp inscan report", error);
            throw error;
        }
    },
    getHubAuditReport: async (params, options = {}) => {
        // Construct query parameters
        const queryParams = {
            page: params.page || 0,
            size: params.size || 10,
            documentNos: params.awbNumbers,

        };

        // Remove undefined values
        const cleanParams = Object.fromEntries(
            Object.entries(queryParams).filter(([_, value]) => value != null)
        );

        // Construct query string
        // const queryString = new URLSearchParams(cleanParams).toString();
        // const url = `${urls.GET_OUTGOING_LCR_REPORT}?${queryString}`;

        try {
            const response = await NormalAPI.Api(GET_HUB_AUDIT_REPORT)
                .getwithParamsAuditReport(cleanParams, options);


            if (response?.response?.status === 200) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                    lastRefreshedAt: response?.response?.data?.lastRefreshedAt || null,
                    nextScheduledRefresh: response?.response?.data?.nextScheduledRefresh || null,
                };
            }
            throw new Error(response?.message || "Failed to fetch incoming LCR report");
        } catch (error) {
            console.error("Error fetching incoming LCR report", error);
            throw error;
        }
    },
    /**
     * Fetch inscan vs audit report data
     * @param {Object} params - Report parameters
     * @param {string} params.fromDate - Start date in YYYY-MM-DD format
     * @param {string} params.toDate - End date in YYYY-MM-DD format
     * @param {Array<string|number>} params.hubIds - Array of hub IDs
     * @param {number} [params.page=1] - Page number (1-based)
     * @param {number} [params.pageSize=10] - Number of items per page
     * @returns {Promise<{data: Array, total: number}>} Report data with pagination info
     */
    getInscanVsAuditReport: async (params, options = {}) => {
        const requestBody = {
            fromDate: params.fromDate,
            toDate: params.toDate,
            hubids: params.hubIds ? params.hubIds.join(",") : undefined,
            page: (params.page || 1) - 1,
            size: params.pageSize || 10,
        };
        const cleanBody = Object.fromEntries(
            Object.entries(requestBody).filter(([_, value]) => value != null)
        );
        // Add doctypes to query params if present
        if (params.docTypes) {
            cleanBody.doctypes = Array.isArray(params.docTypes) ? params.docTypes.join(",") : params.docTypes;
        }
        try {
            const response = await NormalAPI.Api(urls.GET_INSCAN_VS_AUDIT_REPORT)
                .getwithParamsAuditReport(cleanBody, options);
            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                    lastRefreshedAt: response?.response?.data?.lastRefreshedAt || null,
                    nextScheduledRefresh: response?.response?.data?.nextScheduledRefresh || null,
                };
            }
            throw new Error(response?.message || "Failed to fetch inscan vs audit report");
        } catch (error) {
            console.error("Error fetching inscan vs audit report:", error);
            throw error;
        }
    },

    getInscannedShipmentsClickable: async (params, options = {}) => {
        const queryParams = {
            operationDate: params.operationDate,
            hubId: params.hubId,
            doctype: params.doctype,
            page: params.page || 0,
            size: params.size || 10
        };
        const cleanParams = Object.fromEntries(
            Object.entries(queryParams).filter(([_, value]) => value != null)
        );
        try {
            const response = await NormalAPI.Api(GET_INSCANNED_SHIPMENTS_CLICKABLE_REPORT)
                .getwithParamsAuditReport(cleanParams, options);
            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    count: response?.response?.data?.count || 0,
                };
            }
            throw new Error(response?.message || "Failed to fetch inscanned shipments clickable report");
        } catch (error) {
            console.error("Error fetching inscanned shipments clickable report:", error);
            throw error;
        }
    },

    getAuditedShipmentsClickable: async (params, options = {}) => {
        const queryParams = {
            operationDate: params.operationDate,
            hubId: params.hubId,
            doctype: params.doctype,
            page: params.page || 0,
            size: params.size || 10
        };
        const cleanParams = Object.fromEntries(
            Object.entries(queryParams).filter(([_, value]) => value != null)
        );
        try {
            const response = await NormalAPI.Api(GET_AUDITED_SHIPMENTS_CLICKABLE_REPORT)
                .getwithParamsAuditReport(cleanParams, options);
            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    count: response?.response?.data?.count || 0,
                };
            }
            throw new Error(response?.message || "Failed to fetch audited shipments clickable report");
        } catch (error) {
            console.error("Error fetching audited shipments clickable report:", error);
            throw error;
        }
    },

    getNotAuditedShipmentsClickable: async (params, options = {}) => {
        const queryParams = {
            operationDate: params.operationDate,
            hubId: params.hubId,
            doctype: params.doctype,
            page: params.page || 0,
            size: params.size || 10
        };
        const cleanParams = Object.fromEntries(
            Object.entries(queryParams).filter(([_, value]) => value != null)
        );
        try {
            const response = await NormalAPI.Api(GET_NOT_AUDITED_SHIPMENTS_CLICKABLE_REPORT)
                .getwithParamsAuditReport(cleanParams, options);
            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    count: response?.response?.data?.count || 0,
                };
            }
            throw new Error(response?.message || "Failed to fetch not audited shipments clickable report");
        } catch (error) {
            console.error("Error fetching not audited shipments clickable report:", error);
            throw error;
        }
    },



    getExcessInscanReport: async (params, options = {}) => {
        // Transform params to match API requirements
        const queryParams = {
            ...params,
            fromDate: params.fromDate,
            toDate: params.toDate,
            pageNumber: (params.pageNumber || 1) - 1, // Convert 1-based to 0-based pagination
            pageSize: params.pageSize || 10, // Add hub ID support
        };

        // Ensure dates are in the correct format (YYYY-MM-DD)
        if (queryParams.fromDate) {
            queryParams.fromDate = new Date(queryParams.fromDate).toISOString().split("T")[0];
        }
        if (queryParams.toDate) {
            queryParams.toDate = new Date(queryParams.toDate).toISOString().split("T")[0];
        }

        // Remove undefined values
        const cleanParams = Object.fromEntries(
            Object.entries(queryParams).filter(([_, value]) => value != null)
        );


        // Try GET first, if that fails, try POST
        let response;
        try {
            response = await NormalAPI.Api(GET_EXCESS_INSCAN_REPORT)
                .getwithParams(cleanParams, options);
        } catch (getError) {
            response = await NormalAPI.Api(GET_EXCESS_INSCAN_REPORT)
                .postWithHeader(cleanParams, options);
        }

        if (response?.status) {
            return {
                status: true,
                data: response.response?.data || null
            };
        }

        // Check for specific error status codes
        if (response?.response?.status === 403) {
            throw new Error("Authentication failed. Please check your token or login again.");
        }

        if (response?.response?.status === 400) {
            const errorMessage = response?.response?.data?.message || "Bad request";
            throw new Error(errorMessage);
        }

        if (response?.response?.status === 500) {
            const errorMessage = response?.response?.data?.message || "Internal server error";
            throw new Error(errorMessage);
        }

        throw new Error(response?.response?.data?.message || response?.message || "Failed to fetch excess inscan report");
    },

    /**
     * Fetch Enhanced Excess Inscan report data
     * @param {Object} params - Report parameters
     * @param {string} params.fromDate - Start date in YYYY-MM-DD format
     * @param {string} params.toDate - End date in YYYY-MM-DD format
     * @param {string} [params.excessInscanHubIds] - Comma-separated hub IDs for excess inscan
     * @param {string} [params.bookingUpdatedHubIds] - Comma-separated hub IDs for booking updated
     * @param {number} [params.page=0] - Page number (0-based)
     * @param {number} [params.size=100] - Number of items per page
     * @param {Object} [options={}] - Additional options including signal for request cancellation
     * @returns {Promise<{data: Array, total: number, lastRefreshedAt: string}>} Report data with pagination info
     */
    getExcessInscanEnhancedReport: async (params, options = {}) => {
        const requestBody = {
            fromDate: params.fromDate,
            toDate: params.toDate,
            excessInscanHubIds: params.excessInscanHubIds || "",
            bookingUpdatedHubIds: params.bookingUpdatedHubIds || "",
            page: params.page || 0,
            size: params.size || 100
        };

        // Remove undefined values
        const cleanBody = Object.fromEntries(
            Object.entries(requestBody).filter(([_, value]) => value != null)
        );

        const queryString = new URLSearchParams(cleanBody).toString();
        const url = `${GET_EXCESS_INSCAN_ENHANCED_REPORT}?${queryString}`;

        try {
            const response = await NormalAPI.Api(url).getCustomHeader(options);

            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                    lastRefreshedAt: response?.response?.data?.lastRefreshedAt || null,
                    nextScheduledRefresh: response?.response?.data?.nextScheduledRefresh || null,
                };
            }
            throw new Error(response?.message || "Failed to fetch enhanced excess inscan report");
        } catch (error) {
            console.error("Error fetching enhanced excess inscan report:", error);
            throw error;
        }
    },

    /**
     * Download Enhanced Excess Inscan report
     * @param {Object} params - Report parameters
     * @param {string} params.fromDate - Start date in YYYY-MM-DD format
     * @param {string} params.toDate - End date in YYYY-MM-DD format
     * @param {string} [params.excessInscanHubIds] - Comma-separated hub IDs for excess inscan
     * @param {string} [params.bookingUpdatedHubIds] - Comma-separated hub IDs for booking updated
     * @param {Object} [options={}] - Additional options including signal for request cancellation
     * @returns {Promise<Blob>} Report file as blob
     */
    downloadExcessInscanEnhancedReport: async (params, options = {}) => {
        const queryParams = {
            fromDate: params.fromDate,
            toDate: params.toDate,
            excessInscanHubIds: params.excessInscanHubIds || "",
            bookingUpdatedHubIds: params.bookingUpdatedHubIds || ""
        };

        const cleanParams = Object.fromEntries(
            Object.entries(queryParams).filter(([_, value]) => value != null && value !== "")
        );

        const queryString = new URLSearchParams(cleanParams).toString();
        const url = `${DOWNLOAD_EXCESS_INSCAN_ENHANCED_REPORT}?${queryString}`;

        try {
            const response = await NormalAPI.Api(url).getwithParamsAuditReport(cleanParams, options);

            if (response?.status) {
                return response?.response;
            }
            throw new Error(response?.message || "Failed to download enhanced excess inscan report");
        } catch (error) {
            console.error("Error downloading enhanced excess inscan report:", error);
            throw error;
        }
    },

    /**
     * Fetch CP Outscan vs Hub Inscan report data
     * @param {Object} params - Report parameters
     * @param {string} params.fromDate - Start date in YYYY-MM-DD format
     * @param {string} params.toDate - End date in YYYY-MM-DD format
     * @param {Array<string|number>} params.hubIds - Array of hub IDs
     * @param {Array<string|number>} params.cpIds - Array of CP IDs
     * @param {number} [params.pageNum=0] - Page number (0-based)
     * @param {number} [params.pageSize=20] - Number of items per page
     * @returns {Promise<{data: Array, total: number, page: number, pageSize: number}>} Report data with pagination info
     */
    getCpOutscanVsHubInscanReport: async (params, options = {}) => {
        const requestBody = {
            fromDate: params.fromDate,
            toDate: params.toDate,
            hubIds: params.hubIds ? params.hubIds.join(",") : null,
            cpIds: params.cpIds ? params.cpIds.join(",") : null,
            pageNum: params.pageNum || 0,
            pageSize: params.pageSize || 20
        };

        // Remove undefined values
        const cleanBody = Object.fromEntries(
            Object.entries(requestBody).filter(([_, value]) => value != null)
        );

        const queryString = new URLSearchParams(cleanBody).toString();
        const url = `${urls.GET_CP_OUTSCAN_VS_HUB_INSCAN_REPORT}?${queryString}`;

        try {
            const response = await NormalAPI.Api(url).getCustomHeader(options);

            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                    page: cleanBody.pageNum,
                    pageSize: cleanBody.pageSize,
                    lastRefreshedAt: response?.response?.data?.lastRefreshedAt || null,
                    nextScheduledRefresh: response?.response?.data?.nextScheduledRefresh || null,
                };
            }
            throw new Error(response?.message || "Failed to fetch CP outscan vs hub inscan report");
        } catch (error) {
            console.error("Error fetching CP outscan vs hub inscan report:", error);
            throw error;
        }
    },

    /**
     * Fetch Eway Bill report data
     * @param {Object} params - Report parameters
     * @param {string} params.fromDate - Start date in YYYY-MM-DD format
     * @param {string} params.toDate - End date in YYYY-MM-DD format
     * @param {Array<string|number>} params.hubIds - Array of hub IDs
     * @param {Array<string|number>} params.cpIds - Array of CP IDs
     * @param {Array<string>} params.zones - Array of zones
     * @param {Array<string>} params.bookingTypes - Array of booking types
     * @param {number} [params.page=0] - Page number (0-based)
     * @param {number} [params.size=10] - Number of items per page
     * @param {Object} [options={}] - Additional options including signal for request cancellation
     * @returns {Promise<{data: Array, total: number, page: number, pageSize: number}>} Report data with pagination info
     */
    getEwayBillReport: async (params, options = {}) => {
        const requestBody = {
            fromDate: params.fromDate,
            toDate: params.toDate,
            hubIds: params.hubIds ? params.hubIds.join(",") : null,
            cpIds: params.cpIds ? params.cpIds.join(",") : null,
            page: params.page || 0,
            size: params.size || 10,
            zones: params.zones ? params.zones.join(",") : null,
            bookingTypes: params.bookingTypes ? params.bookingTypes.join(",") : null,
        };

        // Remove undefined values
        const cleanBody = Object.fromEntries(
            Object.entries(requestBody).filter(([_, value]) => value != null)
        );

        const queryString = new URLSearchParams(cleanBody).toString();
        const url = `${GET_EWAY_BILL_REPORT}?${queryString}`;

        try {
            const response = await NormalAPI.Api(url).getCustomHeader(options);

            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                    page: cleanBody.page,
                    pageSize: cleanBody.size
                };
            }
            throw new Error(response?.message || "Failed to fetch Eway Bill report");
        } catch (error) {
            console.error("Error fetching Eway Bill report:", error);
            throw error;
        }
    },

    /**
     * Fetch Inscan report data
     * @param {Object} params - Report parameters
     * @param {string} params.fromDate - Start date in YYYY-MM-DD format
     * @param {string} params.toDate - End date in YYYY-MM-DD format
     * @param {Array<string|number>} params.premiseIds - Array of premise IDs (hub IDs)
     * @param {Array<string>} params.serviceTypes - Array of service types
     * @param {Array<string>} params.documentTypes - Array of document types
     * @param {Array<string>} params.bookingTypes - Array of booking types
     * @param {string} params.awbSearch - AWB number search term (comma-separated for multiple AWBs)
     * @param {number} [params.page=0] - Page number (0-based)
     * @param {number} [params.size=10] - Number of items per page
     * @param {Object} [options={}] - Additional options including signal for request cancellation
     * @returns {Promise<{data: Array, total: number, page: number, pageSize: number}>} Report data with pagination info
     */
    getInscanReport: async (params, options = {}) => {
        const requestBody = {
            fromDate: params.fromDate,
            toDate: params.toDate,
            premiseIds: params.premiseIds ? params.premiseIds.join(",") : null,
            serviceTypes: params.serviceTypes ? params.serviceTypes.join(",") : null,
            documentTypes: params.documentTypes ? params.documentTypes.join(",") : null,
            bookingTypes: params.bookingTypes ? params.bookingTypes.join(",") : null,
            awbSearch: params.awbSearch ? params.awbSearch.trim() : null,
            page: params.page || 0,
            size: params.size || 10
        };

        // Remove undefined values
        const cleanBody = Object.fromEntries(
            Object.entries(requestBody).filter(([_, value]) => value != null)
        );

        const queryString = new URLSearchParams(cleanBody).toString();
        const url = `${urls.GET_INSCAN_REPORT}?${queryString}`;

        try {
            const response = await NormalAPI.Api(url).getCustomHeader(options);

            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                    page: cleanBody.page,
                    pageSize: cleanBody.size,
                    lastRefreshedAt: response?.response?.data?.lastRefreshedAt || null,
                    nextScheduledRefresh: response?.response?.data?.nextScheduledRefresh || null,
                };
            }
            throw new Error(response?.message || "Failed to fetch Inscan report");
        } catch (error) {
            console.error("Error fetching Inscan report:", error);
            throw error;
        }
    },

    /**
     * Fetch Wrong Sorting report data
     * @param {Object} params - Report parameters
     * @param {string} params.fromDate - Start date in YYYY-MM-DD format
     * @param {string} params.toDate - End date in YYYY-MM-DD format
     * @param {Array<string|number>} params.fromHubIds - Array of from hub IDs
     * @param {Array<string|number>} params.misrouteHubIds - Array of misroute hub IDs
     * @param {Array<string|number>} params.fromCenterIds - Array of from center IDs
     * @param {Array<string|number>} params.toHubIds - Array of to hub IDs
     * @param {Array<string>} params.serviceTypes - Array of service types
     * @param {number} [params.page=0] - Page number (0-based)
     * @param {number} [params.size=50] - Number of items per page
     * @param {Object} [options={}] - Additional options including signal for request cancellation
     * @returns {Promise<{data: Array, total: number, page: number, pageSize: number}>} Report data with pagination info
     */
    getWrongSortingReport: async (params, options = {}) => {
        const queryParams = {
            fromDate: params.fromDate,
            toDate: params.toDate,
            ...(params.fromHubIds && { fromHubIds: Array.isArray(params.fromHubIds) ? params.fromHubIds.join(",") : params.fromHubIds }),
            ...(params.misrouteHubIds && { misrouteHubIds: Array.isArray(params.misrouteHubIds) ? params.misrouteHubIds.join(",") : params.misrouteHubIds }),
            ...(params.fromCenterIds && { fromCenterIds: Array.isArray(params.fromCenterIds) ? params.fromCenterIds.join(",") : params.fromCenterIds }),
            ...(params.toHubIds && { toHubIds: Array.isArray(params.toHubIds) ? params.toHubIds.join(",") : params.toHubIds }),
            ...(params.toCenterIds && { toCenterIds: Array.isArray(params.toCenterIds) ? params.toCenterIds.join(",") : params.toCenterIds }),
            ...(params.serviceTypes && { serviceTypes: Array.isArray(params.serviceTypes) ? params.serviceTypes.join(",") : params.serviceTypes }),
            ...(params.bookingTypes && { bookingTypes: Array.isArray(params.bookingTypes) ? params.bookingTypes.join(",") : params.bookingTypes }),
            page: params.page ?? 0,
            size: params.size ?? 50
        };

        const cleanParams = Object.fromEntries(
            Object.entries(queryParams).filter(([_, value]) => value != null && value !== "")
        );

        try {
            const response = await NormalAPI.Api(GET_WRONG_SORTING_REPORT)
                .getwithParamsAuditReport(cleanParams, options);

            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                    page: cleanParams.page,
                    pageSize: cleanParams.size,
                    lastRefreshedAt: response?.response?.data?.lastRefreshedAt || null,
                    nextScheduledRefresh: response?.response?.data?.nextScheduledRefresh || null,
                };
            }
            throw new Error(response?.message || "Failed to fetch Wrong Sorting report");
        } catch (error) {
            console.error("Error fetching Wrong Sorting report:", error);
            throw error;
        }
    },

    /**
     * Download Wrong Sorting report
     * @param {Object} params - Report parameters
     * @param {string} params.fromDate - Start date in YYYY-MM-DD format
     * @param {string} params.toDate - End date in YYYY-MM-DD format
     * @param {Array<string|number>} params.fromHubIds - Array of from hub IDs
     * @param {Array<string|number>} params.misrouteHubIds - Array of misroute hub IDs
     * @param {Array<string|number>} params.fromCenterIds - Array of from center IDs
     * @param {Array<string|number>} params.toHubIds - Array of to hub IDs
     * @param {Array<string>} params.serviceTypes - Array of service types
     * @param {Object} [options={}] - Additional options including signal for request cancellation
     * @returns {Promise<Blob>} Report file as blob
     */
    downloadWrongSortingReport: async (params, options = {}) => {
        const queryParams = {
            fromDate: params.fromDate,
            toDate: params.toDate,
            ...(params.fromHubIds && { fromHubIds: Array.isArray(params.fromHubIds) ? params.fromHubIds.join(",") : params.fromHubIds }),
            ...(params.misrouteHubIds && { misrouteHubIds: Array.isArray(params.misrouteHubIds) ? params.misrouteHubIds.join(",") : params.misrouteHubIds }),
            ...(params.fromCenterIds && { fromCenterIds: Array.isArray(params.fromCenterIds) ? params.fromCenterIds.join(",") : params.fromCenterIds }),
            ...(params.toHubIds && { toHubIds: Array.isArray(params.toHubIds) ? params.toHubIds.join(",") : params.toHubIds }),
            ...(params.toCenterIds && { toCenterIds: Array.isArray(params.toCenterIds) ? params.toCenterIds.join(",") : params.toCenterIds }),
            ...(params.serviceTypes && { serviceTypes: Array.isArray(params.serviceTypes) ? params.serviceTypes.join(",") : params.serviceTypes })
        };

        const cleanParams = Object.fromEntries(
            Object.entries(queryParams).filter(([_, value]) => value != null && value !== "")
        );

        try {
            const response = await NormalAPI.Api(DOWNLOAD_WRONG_SORTING_REPORT)
                .getwithParamsAuditReport(cleanParams, options);

            if (response?.status) {
                return response?.response;
            }
            throw new Error(response?.message || "Failed to download Wrong Sorting report");
        } catch (error) {
            console.error("Error downloading Wrong Sorting report:", error);
            throw error;
        }
    },

    /**
     * Fetch Booking vs Delivery report data
     * @param {Object} params - Report parameters
     * @param {string} params.fromDate - Start date in YYYY-MM-DD format
     * @param {string} params.toDate - End date in YYYY-MM-DD format
     * @param {string} [params.serviceType] - Service type filter
     * @param {string} [params.fromHubId] - From hub ID filter
     * @param {string} [params.bookingCpId] - Booking CP ID filter
     * @param {number} [params.page=0] - Page number (0-based)
     * @param {number} [params.size=10] - Number of items per page
     * @param {Object} [options] - Additional options for the request
     * @returns {Promise<{data: Array, total: number}>} Report data with pagination info
     */
    getBookingVsDeliveryReport: async (params, options = {}) => {
        const requestBody = {
            fromDate: params.fromDate,
            toDate: params.toDate,
            ...(params.bookingType && { bookingType: params.bookingType }),
            ...(params.fromHubId && { fromHubId: params.fromHubId }),
            ...(params.bookingCpId && { bookingCpId: params.bookingCpId }),
            page: params.page || 0,
            size: params.size || 10,
        };

        // Remove undefined values
        const cleanBody = Object.fromEntries(
            Object.entries(requestBody).filter(([_, value]) => value != null)
        );

        try {
            const response = await NormalAPI.Api(GET_BOOKING_VS_DELIVERY_REPORT)
                .getwithParamsAuditReport(cleanBody, options);

            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                    lastRefreshedAt: response?.response?.data?.lastRefreshedAt || null,
                    nextScheduledRefresh: response?.response?.data?.nextScheduledRefresh || null,
                };
            }
            throw new Error(response?.message || "Failed to fetch Booking vs Delivery report data");
        } catch (error) {
            console.error("Error fetching Booking vs Delivery report:", error);
            throw error;
        }
    },

    /**
     * Fetch Outscan By Hub To Branch report data
     * @param {Object} params - Report parameters
     * @param {string} params.fromDate - Start date in YYYY-MM-DD format
     * @param {string} params.toDate - End date in YYYY-MM-DD format
     * @param {number} [params.fromHubId] - From hub ID
     * @param {number} [params.toCpId] - To CP ID
     * @param {number} [params.page=0] - Page number (0-based)
     * @param {number} [params.size=10] - Number of items per page
     * @param {Object} [options={}] - Additional options including signal for request cancellation
     * @returns {Promise<{data: Array, total: number}>} Report data with pagination info
     */
    getOutscanByHubToBranch: async (params, options = {}) => {
        // Use single date parameter - prefer date if provided, otherwise use fromDate
        const dateValue = params.date || params.fromDate;
        const queryParams = {
            date: dateValue, // Capital D for GET request
            ...(params.fromHubId && { fromHubId: params.fromHubId }),
            ...(params.hubId && { fromHubId: params.hubId }),
            ...(params.toCpId && { toCpId: params.toCpId }),
            ...(params.deliveryCpId && { toCpId: params.deliveryCpId }),
            page: params.page || 0,
            size: params.size || 10
        };

        // Remove undefined values
        const cleanParams = Object.fromEntries(
            Object.entries(queryParams).filter(([_, value]) => value != null)
        );

        const queryString = new URLSearchParams(cleanParams).toString();
        const url = `${urls.GET_OUTSCAN_BY_HUB_TO_BRANCH}?${queryString}`;

        try {
            const response = await NormalAPI.Api(url).getCustomHeader(options);

            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                };
            }
            throw new Error(response?.message || "Failed to fetch Outscan By Hub To Branch report");
        } catch (error) {
            console.error("Error fetching Outscan By Hub To Branch report:", error);
            throw error;
        }
    },
    /**
     * Download Booking vs Delivery report
     * @param {Object} params - Report parameters
     * @param {string} params.fromDate - Start date in YYYY-MM-DD format
     * @param {string} params.toDate - End date in YYYY-MM-DD format
     * @param {string} [params.serviceTypes] - Service types filter (comma-separated)
     * @param {string} [params.fromHubIds] - From hub IDs filter (comma-separated)
     * @param {string} [params.bookingCpIds] - Booking CP IDs filter (comma-separated)
     * @returns {Promise<void>}
     */
    downloadBookingVsDeliveryReport: async (params, options = {}) => {
        const downloadParams = {
            fromDate: params.fromDate,
            toDate: params.toDate,
            ...(params.serviceTypes && { serviceTypes: params.serviceTypes }),
            ...(params.fromHubIds && { fromHubIds: params.fromHubIds }),
            ...(params.bookingCpIds && { bookingCpIds: params.bookingCpIds }),
        };

        // Remove undefined values
        const cleanParams = Object.fromEntries(
            Object.entries(downloadParams).filter(([_, value]) => value != null && value !== "")
        );

        try {
            const response = await NormalAPI.Api(DOWNLOAD_BOOKING_VS_DELIVERY_REPORT)
                .getwithParamsAuditReport(cleanParams, options);

            if (response?.status) {
                return response?.response;
            }
            throw new Error(response?.message || "Failed to download Booking vs Delivery report");
        } catch (error) {
            console.error("Error downloading Booking vs Delivery report:", error);
            throw error;
        }
    },

    /**
     * Get Inscan By CP report data
     * @param {Object} params - Report parameters
     * @param {string} params.fromDate - Start date in YYYY-MM-DD format
     * @param {string} params.toDate - End date in YYYY-MM-DD format
     * @param {number} [params.fromHubId] - From hub ID
     * @param {number} [params.toCpId] - To CP ID
     * @param {number} [params.page=0] - Page number (0-based)
     * @param {number} [params.size=10] - Page size
     * @param {Object} [options={}] - Additional options including signal for request cancellation
     * @returns {Promise<{data: Array, total: number}>} Report data and total count
     */
    getInscanByCP: async (params, options = {}) => {
        // Use single date parameter - prefer date if provided, otherwise use fromDate
        const dateValue = params.date || params.fromDate;
        const queryParams = {
            date: dateValue, // lowercase d
            ...(params.toCpId && { toCpId: params.toCpId }),
            ...(params.deliveryCpId && { toCpId: params.deliveryCpId }),
            page: params.page || 0,
            size: params.size || 10,
            ...(params.fromHubId && { fromHubId: params.fromHubId }),
            ...(params.hubId && { fromHubId: params.hubId })
        };

        // Remove undefined values
        const cleanParams = Object.fromEntries(
            Object.entries(queryParams).filter(([_, value]) => value != null)
        );

        const queryString = new URLSearchParams(cleanParams).toString();
        const url = `${urls.GET_INSCAN_BY_CP}?${queryString}`;

        try {
            const response = await NormalAPI.Api(url).getCustomHeader(options);

            if (response?.status) {
                return {
                    data: response?.response?.data?.data || response?.response?.data || [],
                    total: response?.response?.data?.count || response?.response?.total || 0
                };
            }
            throw new Error(response?.message || "Failed to fetch Inscan By CP report");
        } catch (error) {
            console.error("Error fetching Inscan By CP report:", error);
            throw error;
        }
    },

    /**
     * Get Inscan By Other CP report data
     * @param {Object} params - Report parameters
     * @param {string} params.date - Date in YYYY-MM-DD format
     * @param {number} [params.fromHubId] - From hub ID
     * @param {number} [params.toCpId] - To CP ID
     * @param {number} [params.page=0] - Page number (0-based)
     * @param {number} [params.size=10] - Page size
     * @param {Object} [options={}] - Additional options including signal for request cancellation
     * @returns {Promise<{data: Array, total: number}>} Report data and total count
     */
    getInscanByOtherCP: async (params, options = {}) => {
        // Use single date parameter - prefer date if provided, otherwise use fromDate
        const dateValue = params.date || params.fromDate;
        const queryParams = {
            date: dateValue, // lowercase d
            page: params.page || 0,
            size: params.size || 10,
            ...(params.fromHubId && { fromHubId: params.fromHubId }),
            ...(params.hubId && { fromHubId: params.hubId }),
            ...(params.toCpId && { toCpId: params.toCpId }),
            ...(params.deliveryCpId && { toCpId: params.deliveryCpId })
        };

        // Remove undefined values
        const cleanParams = Object.fromEntries(
            Object.entries(queryParams).filter(([_, value]) => value != null)
        );

        const queryString = new URLSearchParams(cleanParams).toString();
        const url = `${urls.GET_INSCAN_BY_OTHER_CP}?${queryString}`;

        try {
            const response = await NormalAPI.Api(url).getCustomHeader(options);

            if (response?.status) {
                return {
                    data: response?.response?.data?.data || response?.response?.data || [],
                    total: response?.response?.data?.count || response?.response?.total || 0
                };
            }
            throw new Error(response?.message || "Failed to fetch Inscan By Other CP report");
        } catch (error) {
            console.error("Error fetching Inscan By Other CP report:", error);
            throw error;
        }
    },

    /**
     * Fetch Hubwise Shipments Inscan vs Outscan report data
     * @param {Object} params - Report parameters
     * @param {string} params.fromDate - Start date in YYYY-MM-DD format
     * @param {string} params.toDate - End date in YYYY-MM-DD format
     * @param {Array<string|number>} params.hubIds - Array of hub IDs
     * @param {Array<string>} params.zones - Array of zones
     * @param {number} [params.page=0] - Page number (0-based)
     * @param {number} [params.size=10] - Number of items per page
     * @param {Object} [options={}] - Additional options including signal for request cancellation
     * @returns {Promise<{data: Array, total: number, page: number, pageSize: number}>} Report data with pagination info
     */
    getHubwiseShipmentsInscanVsOutscanReport: async (params, options = {}) => {
        const requestBody = {
            fromDate: params.fromDate,
            toDate: params.toDate,
            hubIds: params.hubIds ? params.hubIds.join(",") : null,
            zones: params.zones ? params.zones.join(",") : null,
            page: params.page || 0,
            size: params.size || 10
        };

        // Remove undefined values
        const cleanBody = Object.fromEntries(
            Object.entries(requestBody).filter(([_, value]) => value != null)
        );

        const queryString = new URLSearchParams(cleanBody).toString();
        const url = `${GET_HUBWISE_SHIPMENTS_INSCAN_VS_OUTSCAN_REPORT}?${queryString}`;

        try {
            const response = await NormalAPI.Api(url).getCustomHeader(options);

            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                    page: cleanBody.page,
                    pageSize: cleanBody.size,
                    lastRefreshedAt: response?.response?.data?.lastRefreshedAt || null,
                    nextScheduledRefresh: response?.response?.data?.nextScheduledRefresh || null,
                };
            }
            throw new Error(response?.message || "Failed to fetch Hubwise Shipments Inscan vs Outscan report");
        } catch (error) {
            console.error("Error fetching Hubwise Shipments Inscan vs Outscan report:", error);
            throw error;
        }
    },

    /**
     * Fetch delivery scan by branch report data
     * @param {Object} params - Report parameters
     * @param {string} params.fromDate - Start date in YYYY-MM-DD format
     * @param {string} params.toDate - End date in YYYY-MM-DD format
     * @param {number} [params.hubId] - Hub ID
     * @param {number} [params.deliveryCpId] - Delivery CP ID
     * @param {number} [params.page=0] - Page number (0-based)
     * @param {number} [params.size=10] - Number of items per page
     * @param {Object} [options] - Additional options for the API call
     * @returns {Promise<{data: Array, total: number}>} Report data with pagination info
     */
    getDeliveryScanByBranch: async (params, options = {}) => {
        // Use single date parameter - prefer date if provided, otherwise use fromDate
        const dateValue = params.date || params.fromDate;
        const queryParams = {
            date: dateValue, // lowercase d
            ...(params.hubId && { hubId: params.hubId }),
            ...(params.toCpId && { toCpId: params.toCpId }),
            ...(params.deliveryCpId && { toCpId: params.deliveryCpId }),
            page: params.page || 0,
            size: params.size || 10
        };

        // Remove undefined values
        const cleanParams = Object.fromEntries(
            Object.entries(queryParams).filter(([_, value]) => value != null)
        );

        const queryString = new URLSearchParams(cleanParams).toString();
        const url = `${urls.GET_DELIVERY_SCAN_BY_BRANCH}?${queryString}`;

        try {
            const response = await NormalAPI.Api(url).getCustomHeader(options);

            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                };
            }
            throw new Error(response?.message || "Failed to fetch Delivery Scan By Branch report");
        } catch (error) {
            console.error("Error fetching Delivery Scan By Branch report:", error);
            throw error;
        }
    },

    /**
     * Fetch Force Attempt Shipment Details data
     * @param {Object} params - Report parameters
     * @param {string} params.fromDate - Start date in YYYY-MM-DD format
     * @param {string} params.toDate - End date in YYYY-MM-DD format
     * @param {number} [params.premiseId] - Premise ID
     * @param {number} [params.page=0] - Page number (0-based)
     * @param {number} [params.size=10] - Number of items per page
     * @param {Object} [options] - Additional options for the API call
     * @returns {Promise<{data: Array, total: number}>} Report data with pagination info
     */
    getForceAttemptShipmentDetails: async (params, options = {}) => {
        const queryParams = {
            fromDate: params.fromDate,
            toDate: params.toDate,
            ...(params.premiseId && { premiseId: params.premiseId }),
            page: params.page || 0,
            size: params.size || 10
        };

        // Remove undefined values
        const cleanParams = Object.fromEntries(
            Object.entries(queryParams).filter(([_, value]) => value != null)
        );

        const queryString = new URLSearchParams(cleanParams).toString();
        const url = `${urls.GET_FORCE_ATTEMPT_SHIPMENT_DETAILS}?${queryString}`;

        try {
            const response = await NormalAPI.Api(url).getCustomHeader(options);

            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                };
            }
            throw new Error(response?.message || "Failed to fetch Force Attempt Shipment Details");
        } catch (error) {
            console.error("Error fetching Force Attempt Shipment Details:", error);
            throw error;
        }
    },

    /**
     * Fetch Incoming Outgoing Shipment Details data
     * @param {Object} params - Report parameters
     * @param {string} params.bagBarcodeNo - Bag barcode number
     * @param {number} [params.page=0] - Page number (0-based)
     * @param {number} [params.size=10] - Number of items per page
     * @param {Object} [options] - Additional options for the API call
     * @returns {Promise<{data: Array, total: number}>} Report data with pagination info
     */
    getIncomingOutgoingShipmentDetails: async (params, options = {}) => {
        const queryParams = {
            bagBarcodeNo: params.bagBarcodeNo,
            page: params.page || 0,
            size: params.size || 10
        };

        // Remove undefined values
        const cleanParams = Object.fromEntries(
            Object.entries(queryParams).filter(([_, value]) => value != null)
        );

        const queryString = new URLSearchParams(cleanParams).toString();
        const url = `${urls.GET_INCOMING_OUTGOING_SHIPMENT_DETAILS}?${queryString}`;

        try {
            const response = await NormalAPI.Api(url).getCustomHeader(options);

            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                };
            }
            throw new Error(response?.message || "Failed to fetch Incoming Outgoing Shipment Details");
        } catch (error) {
            console.error("Error fetching Incoming Outgoing Shipment Details:", error);
            throw error;
        }
    },

    /**
     * Fetch hub inscan clickable report data
     * @param {Object} params - Report parameters
     * @param {string} params.operationDate - Operation date in YYYY-MM-DD format
     * @param {number} params.hubId - Hub ID
     * @param {number} params.bookingCpId - Booking CP ID
     * @param {number} [params.page=0] - Page number (0-based)
     * @param {number} [params.size=10] - Number of items per page
     * @param {Object} [options={}] - Additional options including signal for request cancellation
     * @returns {Promise<{data: Array, count: number}>} Report data with count
     */
    getHubInscanClickableReport: async (params, options = {}) => {
        try {
            const queryParams = {
                operationDate: params.operationDate,
                hubId: params.hubId,
                bookingCpId: params.bookingCpId,
                page: params.page || 0,
                size: params.size || 10
            };

            const response = await NormalAPI.Api(GET_HUB_INSCAN_CLICKABLE_REPORT)
                .getwithParams(queryParams, options);

            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    count: response?.response?.data?.count || 0
                };
            }
            throw new Error(response?.message || "Failed to fetch hub inscan clickable report");
        } catch (error) {
            console.error("Error fetching hub inscan clickable report:", error);
            throw error;
        }
    },

    /**
     * Fetch CP outscan clickable report data
     * @param {Object} params - Report parameters
     * @param {string} params.operationDate - Operation date in YYYY-MM-DD format
     * @param {number} params.bookingCpId - Booking CP ID
     * @param {number} params.hubId - Hub ID
     * @param {number} [params.page=0] - Page number (0-based)
     * @param {number} [params.size=10] - Number of items per page
     * @param {Object} [options={}] - Additional options including signal for request cancellation
     * @returns {Promise<{data: Array, count: number}>} Report data with count
     */
    getCpOutscanClickableReport: async (params, options = {}) => {
        try {
            const queryParams = {
                operationDate: params.operationDate,
                bookingCpId: params.bookingCpId,
                hubId: params.hubId,
                page: params.page || 0,
                size: params.size || 10
            };

            const response = await NormalAPI.Api(GET_CP_OUTSCAN_CLICKABLE_REPORT)
                .getwithParams(queryParams, options);

            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    count: response?.response?.data?.count || 0
                };
            }
            throw new Error(response?.message || "Failed to fetch CP outscan clickable report");
        } catch (error) {
            console.error("Error fetching CP outscan clickable report:", error);
            throw error;
        }
    },

    /**
     * Fetch shipment inscan clickable report data
     * @param {Object} params - Report parameters
     * @param {string} params.operationDate - Operation date in YYYY-MM-DD format
     * @param {number} params.premiseId - Premise ID
     * @param {number} [params.page=0] - Page number (0-based)
     * @param {number} [params.size=10] - Number of items per page
     * @param {Object} [options={}] - Additional options including signal for request cancellation
     * @returns {Promise<{data: Array, count: number}>} Report data with count
     */
    getShipmentInscanClickableReport: async (params, options = {}) => {
        try {
            const queryParams = {
                operationDate: params.operationDate,
                premiseId: params.premiseId,
                page: params.page || 0,
                size: params.size || 10
            };

            const response = await NormalAPI.Api(GET_SHIPMENT_INSCAN_CLICKABLE_REPORT)
                .getwithParams(queryParams, options);

            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    count: response?.response?.data?.count || 0
                };
            }
            throw new Error(response?.message || "Failed to fetch shipment inscan clickable report");
        } catch (error) {
            console.error("Error fetching shipment inscan clickable report:", error);
            throw error;
        }
    },

    /**
     * Fetch shipment outscan clickable report data
     * @param {Object} params - Report parameters
     * @param {string} params.operationDate - Operation date in YYYY-MM-DD format
     * @param {number} params.premiseId - Premise ID
     * @param {number} [params.page=0] - Page number (0-based)
     * @param {number} [params.size=10] - Number of items per page
     * @param {Object} [options={}] - Additional options including signal for request cancellation
     * @returns {Promise<{data: Array, count: number}>} Report data with count
     */
    getShipmentOutscanClickableReport: async (params, options = {}) => {
        try {
            const queryParams = {
                operationDate: params.operationDate,
                premiseId: params.premiseId,
                page: params.page || 0,
                size: params.size || 10
            };

            const response = await NormalAPI.Api(GET_SHIPMENT_OUTSCAN_CLICKABLE_REPORT)
                .getwithParams(queryParams, options);

            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    count: response?.response?.data?.count || 0
                };
            }
            throw new Error(response?.message || "Failed to fetch shipment outscan clickable report");
        } catch (error) {
            console.error("Error fetching shipment outscan clickable report:", error);
            throw error;
        }
    },

    /**
     * Fetch shipment pending clickable report data
     * @param {Object} params - Report parameters
     * @param {string} params.operationDate - Operation date in YYYY-MM-DD format
     * @param {number} params.premiseId - Premise ID
     * @param {number} [params.page=0] - Page number (0-based)
     * @param {number} [params.size=10] - Number of items per page
     * @param {Object} [options={}] - Additional options including signal for request cancellation
     * @returns {Promise<{data: Array, count: number}>} Report data with count
     */
    getShipmentPendingClickableReport: async (params, options = {}) => {
        try {
            const queryParams = {
                operationDate: params.operationDate,
                premiseId: params.premiseId,
                page: params.page || 0,
                size: params.size || 10
            };

            const response = await NormalAPI.Api(GET_SHIPMENT_PENDING_CLICKABLE_REPORT)
                .getwithParams(queryParams, options);

            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    count: response?.response?.data?.count || 0
                };
            }
            throw new Error(response?.message || "Failed to fetch shipment pending clickable report");
        } catch (error) {
            console.error("Error fetching shipment pending clickable report:", error);
            throw error;
        }
    },

    /**
     * Fetch Control Tower report data
     * @param {Object} params - Report parameters
     * @param {string} params.fromDate - Start date in YYYY-MM-DD format
     * @param {string} params.toDate - End date in YYYY-MM-DD format
     * @param {string} [params.status] - Shipment status
     * @param {Array<string>} [params.serviceTypes] - Array of service types
     * @param {Array<number>} [params.originHubIds] - Array of origin hub IDs
     * @param {Array<number>} [params.currentLocationIds] - Array of current location hub IDs
     * @param {Array<number>} [params.destinationHubIds] - Array of destination hub IDs
     * @param {number} [params.page=0] - Page number (0-based)
     * @param {number} [params.size=100] - Number of items per page
     * @param {Object} [options={}] - Additional options including signal for request cancellation
     * @returns {Promise<{data: Array, total: number, page: number, pageSize: number}>} Report data with pagination info
     */


    getControlTowerReportA3: async (params, options = {}) => {
        // Build query string from params
        console.log("🔥 params A3", params);
        const queryParams = new URLSearchParams();

        if (params.fromDate) queryParams.append("fromDate", params.fromDate);
        if (params.toDate) queryParams.append("toDate", params.toDate);

        // Map status to statuses
        if (params.status) {
            const statusVal = Array.isArray(params.status) ? params.status.join(",") : params.status;
            queryParams.append("statuses", statusVal);
        }

        // Latest Status Date Range
        if (params.latestStatusTimeFrom) queryParams.append("latestStatusTimeFrom", params.latestStatusTimeFrom);
        if (params.latestStatusTimeTo) queryParams.append("latestStatusTimeTo", params.latestStatusTimeTo);

        // Movement Types
        if (params.movementTypes) {
            const val = Array.isArray(params.movementTypes) ? params.movementTypes.join(",") : params.movementTypes;
            queryParams.append("movementTypes", val);
        }

        // Is Closed List
        if (params.isClosedList) {
            // ensure it is passed as string "yes"/"no" from the component, or convert here if needed. 
            // The user curl says isClosedList=no.
            const val = Array.isArray(params.isClosedList) ? params.isClosedList.join(",") : params.isClosedList;
            queryParams.append("isClosedList", val);
        }

        if (params.serviceTypes && params.serviceTypes.length > 0) {
            const val = Array.isArray(params.serviceTypes) ? params.serviceTypes.join(",") : params.serviceTypes;
            queryParams.append("serviceTypes", val);
        }

        if (params.originHubIds && params.originHubIds.length > 0) {
            const val = Array.isArray(params.originHubIds) ? params.originHubIds.join(",") : params.originHubIds;
            queryParams.append("originHubIds", val);
        }

        if (params.destinationHubIds && params.destinationHubIds.length > 0) {
            const val = Array.isArray(params.destinationHubIds) ? params.destinationHubIds.join(",") : params.destinationHubIds;
            queryParams.append("destinationHubIds", val);
        }

        if (params.currentHubIds && params.currentHubIds.length > 0) {
            const val = Array.isArray(params.currentHubIds) ? params.currentHubIds.join(",") : params.currentHubIds;
            queryParams.append("currentHubIds", val);
        }

        if (params.page !== undefined) queryParams.append("page", params.page);
        if (params.size !== undefined) queryParams.append("size", params.size);

        const url = `${GET_CONTROL_TOWER_A3}?${queryParams.toString()}`;

        try {
            const response = await NormalAPI.Api(url).getCustomHeader(options);

            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                    page: params.page || 0,
                    pageSize: params.size || 10
                };
            }
            throw new Error(response?.message || "Failed to fetch Control Tower Report New");
        } catch (error) {
            console.error("Error fetching Control Tower Report New:", error);
            throw error;
        }
    },

    /**
     * Fetch Finalized Bags Pending Outscan report data
     * @param {Object} params - Report parameters
     * @param {string} params.fromDate - Start date in YYYY-MM-DD format
     * @param {string} params.toDate - End date in YYYY-MM-DD format
     * @param {string} [params.premiseIds] - Comma-separated premise IDs
     * @param {string} [params.destinationHubIds] - Comma-separated destination hub IDs
     * @param {number} [params.page=0] - Page number (0-based)
     * @param {number} [params.size=100] - Number of items per page
     * @param {Object} [options={}] - Additional options including signal for request cancellation
     * @returns {Promise<{data: Array, total: number, lastRefreshedAt: string}>} Report data with pagination info
     */
    getFinalizedBagsPendingOutscanReport: async (params, options = {}) => {
        const requestBody = {
            fromDate: params.fromDate,
            toDate: params.toDate,
            premiseIds: params.premiseIds || "",
            destinationHubIds: params.destinationHubIds || "",
            page: params.page || 0,
            size: params.size || 100
        };

        // Remove undefined values
        const cleanBody = Object.fromEntries(
            Object.entries(requestBody).filter(([_, value]) => value != null)
        );

        const queryString = new URLSearchParams(cleanBody).toString();
        const url = `${GET_FINALIZED_BAGS_PENDING_OUTSCAN_REPORT}?${queryString}`;

        try {
            const response = await NormalAPI.Api(url).getCustomHeader(options);

            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                    lastRefreshedAt: response?.response?.data?.lastRefreshedAt || null,
                    nextScheduledRefresh: response?.response?.data?.nextScheduledRefresh || null,
                };
            }
            throw new Error(response?.message || "Failed to fetch finalized bags pending outscan report");
        } catch (error) {
            console.error("Error fetching finalized bags pending outscan report:", error);
            throw error;
        }
    },

    getInscannedClickableReport: async (params, options = {}) => {
        try {
            const queryParams = {
                operationDate: params.operationDate,
                hubId: params.hubId,
                type: params.type,
                page: params.page || 0,
                size: params.size || 10
            };
            const response = await NormalAPI.Api(GET_INSCANNED_CLICKABLE_REPORT).getwithParams(queryParams, options);
            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    count: response?.response?.data?.count || 0
                };
            }
            throw new Error(response?.message || "Failed to fetch inscanned clickable report");
        } catch (error) {
            console.error("Error fetching inscanned clickable report:", error);
            throw error;
        }
    },

    getHubInscannedClickableReport: async (params, options = {}) => {
        try {
            const queryParams = {
                operationDate: params.operationDate,
                hubId: params.hubId,
                type: params.type,
                page: params.page || 0,
                size: params.size || 10
            };
            const response = await NormalAPI.Api(GET_HUB_INSCANNED_CLICKABLE_REPORT).getwithParams(queryParams, options);
            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    count: response?.response?.data?.count || 0
                };
            }
            throw new Error(response?.message || "Failed to fetch hub inscanned clickable report");
        } catch (error) {
            console.error("Error fetching hub inscanned clickable report:", error);
            throw error;
        }
    },

    getInscannedAtTransitClickableReport: async (params, options = {}) => {
        try {
            const queryParams = {
                operationDate: params.operationDate,
                hubId: params.hubId,
                type: params.type,
                page: params.page || 0,
                size: params.size || 10
            };
            const response = await NormalAPI.Api(GET_INSCANNED_AT_TRANSIT_CLICKABLE_REPORT).getwithParams(queryParams, options);
            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    count: response?.response?.data?.count || 0
                };
            }
            throw new Error(response?.message || "Failed to fetch inscanned at transit clickable report");
        } catch (error) {
            console.error("Error fetching inscanned at transit clickable report:", error);
            throw error;
        }
    },

    getTotalAssignedClickableReport: async (params, options = {}) => {
        try {
            const queryParams = {
                operationDate: params.operationDate,
                hubId: params.hubId,
                type: params.type,
                page: params.page || 0,
                size: params.size || 10
            };
            const response = await NormalAPI.Api(GET_TOTAL_ASSIGNED_CLICKABLE_REPORT).getwithParams(queryParams, options);
            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    count: response?.response?.data?.count || 0
                };
            }
            throw new Error(response?.message || "Failed to fetch total assigned clickable report");
        } catch (error) {
            console.error("Error fetching total assigned clickable report:", error);
            throw error;
        }
    },

    getTotalAuditedClickableReport: async (params, options = {}) => {
        try {
            const queryParams = {
                operationDate: params.operationDate,
                hubId: params.hubId,
                type: params.type,
                page: params.page || 0,
                size: params.size || 10
            };
            const response = await NormalAPI.Api(GET_TOTAL_AUDITED_CLICKABLE_REPORT).getwithParams(queryParams, options);
            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    count: response?.response?.data?.count || 0
                };
            }
            throw new Error(response?.message || "Failed to fetch total audited clickable report");
        } catch (error) {
            console.error("Error fetching total audited clickable report:", error);
            throw error;
        }
    },
    getSameDayDeliveryClickableReport: async (params, options = {}) => {
        const queryParams = {
            date: params.date,
            fromDate: params.fromDate,
            ...(params.fromHubId && { fromHubId: params.fromHubId }),
            ...(params.toCpId && { toCpId: params.toCpId }),
            page: params.page || 0,
            size: params.size || 10
        };

        const cleanParams = Object.fromEntries(
            Object.entries(queryParams).filter(([_, value]) => value != null && value !== "")
        );

        const queryString = new URLSearchParams(cleanParams).toString();
        const url = `${urls.GET_SAME_DAY_DELIVERY_CLICKABLE_REPORT}?${queryString}`;

        try {
            const response = await NormalAPI.Api(url).getCustomHeader(options);
            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                };
            }
            throw new Error(response?.message || "Failed to fetch same day delivery report");
        } catch (error) {
            console.error("Error fetching same day delivery report:", error);
            throw error;
        }
    },

    /**
     * Fetch DRS By Other CP report data
     * @param {Object} params - Report parameters
     * @param {string} params.date - Date in YYYY-MM-DD format
     * @param {number} [params.hubId] - Hub ID
     * @param {number} [params.toCpId] - To CP ID
     * @param {number} [params.page=0] - Page number (0-based)
     * @param {number} [params.size=10] - Number of items per page
     * @param {Object} [options] - Additional options for the API call
     * @returns {Promise<{data: Array, total: number}>} Report data with pagination info
     */
    getDrsByOtherCp: async (params, options = {}) => {
        // Use single date parameter - prefer date if provided, otherwise use fromDate
        const dateValue = params.date || params.fromDate;
        const queryParams = {
            date: dateValue,
            ...(params.hubId && { hubId: params.hubId }),
            ...(params.fromHubId && { hubId: params.fromHubId }), // Handle fromHubId compatibility 
            ...(params.toCpId && { toCpId: params.toCpId }),
            page: params.page || 0,
            size: params.size || 10
        };

        const cleanParams = Object.fromEntries(
            Object.entries(queryParams).filter(([_, value]) => value != null)
        );

        const queryString = new URLSearchParams(cleanParams).toString();
        const url = `${urls.GET_DRS_BY_OTHER_CP}?${queryString}`;

        try {
            const response = await NormalAPI.Api(url).getCustomHeader(options);

            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                };
            }
            throw new Error(response?.message || "Failed to fetch DRS By Other CP report");
        } catch (error) {
            console.error("Error fetching DRS By Other CP report:", error);
            throw error;
        }
    },

    /**
     * Fetch Same Day Delivery By Other CP report data
     * @param {Object} params - Report parameters
     * @param {string} params.date - Date in YYYY-MM-DD format
     * @param {number} [params.fromHubId] - From Hub ID
     * @param {number} [params.toCpId] - To CP ID
     * @param {number} [params.page=0] - Page number (0-based)
     * @param {number} [params.size=10] - Number of items per page
     * @param {Object} [options] - Additional options for the API call
     * @returns {Promise<{data: Array, total: number}>} Report data with pagination info
     */
    getSameDayDeliveryByOtherCp: async (params, options = {}) => {
        // Use single date parameter - prefer date if provided, otherwise use fromDate
        const dateValue = params.date || params.fromDate;
        const queryParams = {
            date: dateValue,
            ...(params.fromHubId && { fromHubId: params.fromHubId }),
            ...(params.hubId && { fromHubId: params.hubId }), // Handle hubId compatibility
            ...(params.toCpId && { toCpId: params.toCpId }),
            page: params.page || 0,
            size: params.size || 10
        };

        const cleanParams = Object.fromEntries(
            Object.entries(queryParams).filter(([_, value]) => value != null)
        );

        const queryString = new URLSearchParams(cleanParams).toString();
        const url = `${urls.GET_SAME_DAY_DELIVERY_BY_OTHER_CP}?${queryString}`;

        try {
            const response = await NormalAPI.Api(url).getCustomHeader(options);

            if (response?.status) {
                return {
                    data: response?.response?.data?.data || [],
                    total: response?.response?.data?.count || 0,
                };
            }
            throw new Error(response?.message || "Failed to fetch Same Day Delivery By Other CP report");
        } catch (error) {
            console.error("Error fetching Same Day Delivery By Other CP report:", error);
            throw error;
        }
    },
};
